import * as React from "react";
import type { SVGProps } from "react";
const SvgTag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#tag_svg__a)">
      <path d="M8 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
      <path d="M8 10.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
      <path d="M13.64 22a3 3 0 0 1-2.14-.89L3.39 13a3 3 0 0 1-.89-2.14V7a4 4 0 0 1 4-4h3.86a3 3 0 0 1 2.14.88L20.61 12a3 3 0 0 1 0 4.28l-4.83 4.83a3 3 0 0 1-2.14.89M6.5 5a2 2 0 0 0-2 2v3.86a1 1 0 0 0 .3.72l8.12 8.12a1 1 0 0 0 1.45 0l4.83-4.83a1 1 0 0 0 0-1.45L11.08 5.3a1 1 0 0 0-.72-.3z" />
    </g>
    <defs>
      <clipPath id="tag_svg__a">
        <path fill="#fff" d="M2.5 3h19v19h-19z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTag;
